import { useEffect, useRef, useState } from 'react';
import FormFieldGenerator from './FormFieldGenerator';
import JSDisplayValue from "./JSDisplayValue";
import CanvasDraw from "react-canvas-draw";
import Btn from './Btn';
import { _zzsurvey_ajax, _zzsurvey_authUtils } from '../utils/zz/zz-zzsurvey-ajax-adapter';
import { config_TOKEN_LOCAL_KEY } from './ZZTempSurvey';
import SpinnerClassic from './SpinnerClassic';
import jwt from 'jsonwebtoken';


/*
https://github.com/embiem/react-canvas-draw
*/


// DEFAULT COMPONENT
const ZZTempSignConsent = (props) => {
  // const canvasRef = useRef(null);
  const canvasDrawRef = useRef(null);
  const {
    routeSimple,
    error_msg_handle,
  } = props;
  //
  // const routeSimple = appState.routeSimple;
  const route_params = routeSimple.route_params;
  const token_from_signature_url = route_params.token_from_signature_url;
  const cdp_customer_id = route_params.cdp_customer_id;
  const consent_id = route_params.consent_id;
  //
  const [imgSrcBlob, setImgSrcBlob] = useState(null);
  console.log('imgSrcBlob', imgSrcBlob);
  //
  const [token, setToken] = useState(null);
  const [consent, setConsent] = useState({
    fetching: true,
    data: {},
  });
  //
  const [thankYou, setThankYou] = useState(false);
  const [canceled, setCanceled] = useState(false);
  //
  const [tokenFromSignatureURL, setTokenFromSignatureURL] = useState(null);

  useEffect(() => { // component did mount AUTO LOGIN
    //
    //
    (async () => {
      //
      // --- AUTH procedure autologin by token 
      const _local_token = await window.localStorage.getItem(config_TOKEN_LOCAL_KEY);
      console.log('_local_token', _local_token);
      // _zzsurvey_authUtils.setToken(_local_token);
      if (typeof _local_token === 'string' && _local_token !== '') {
        console.log('*** will do AUTOLOGIN BY TOKEN');

        // TODO
        _zzsurvey_authUtils.setToken(_local_token);
        setToken(_local_token);

      } else {
        console.log('*** no local token - skip AUTOLOGIN');
      }
    })();
    //
    //
  }, []);

  useEffect(() => {
    const url_full = window.location.href;
    const url = new URL(url_full); //
    const token_from_signature_url = url.searchParams.get("token");
    console.log('token_from_signature_url', token_from_signature_url);
    setTokenFromSignatureURL(token_from_signature_url);
  }, []);

  useEffect(() => {
    //
    //
    const token_from_signature_url = tokenFromSignatureURL;
    if (typeof token_from_signature_url === 'string' && token_from_signature_url !== '') {
      const { cdp_customer_id, consent_id } = jwt.decode(token_from_signature_url);
      _zzsurvey_ajax.getConsent(consent_id)
        .then(response => {
          /*
          {
             "consent_id": 1,
             "title": "SAGLASNOST ZA OBRADU LIČNIH PODATAKA I KOMUNIKACIJU",
             "internal_name": "Saglasnost 1",
             "text": "\"Potpisivanjem ove saglasnosti, potvrđujem da sam upoznat/a sa uslovima poslovanja\"",
             "terms_text": "SAGLASNOST ZA OBRADU LIČNIH PODATAKA I KOMUNIKACIJU\n\nPotvrđujem da dajem saglasnost za primanje personalizovanih ponuda u vezi sa kupovinom vozila, postprodajnih proizvoda i usluga, kao i informacija o događajima, pogodnostima i drugim aktuelnostima koje se odnose na vozila i usluge u domenu auto-industrije.\n\nTakođe, dozvoljavam upotrebu sledećih kanala komunikacije u navedene svrhe:\n  - E-pošta\n  - SMS\n  - Telefon\n  - Obična pošta\n\nPored toga, saglasan/saglasna sam da primam pozive za učešće u anketama o zadovoljstvu proizvodima i uslugama.\n\nSaglasan/saglasna sam da se moji lični podaci (ime, prezime, adresa, e-adresa, broj telefona, broj šasije, marka, model, verzija i starost vozila) obrađuju u skladu sa važećim propisima o zaštiti podataka o ličnosti.\n\nUpoznat/a sam sa informacijama o obradi mojih ličnih podataka.",
             "date_created": "2025-05-07T10:20:33.000Z",
             "client_id": 1
         }
         */
          console.log('response getConsent', response);
          if (response?.data?.consent) {
            setConsent({
              fetching: false,
              data: response?.data?.consent,
            });
          } else {
            // TODO
          }
        })
        .catch(err => {
          console.log('CATCH error getConsent');
          error_msg_handle(err);
        });
    }
    //
    //
  }, [tokenFromSignatureURL]);


  //
  const handleExportImageFromCanvas = () => {
    if (canvasDrawRef.current) {
      // const base64 = canvasDrawRef.current.canvasContainer.childNodes[1].toDataURL(); // blob
      // console.log('base64', base64);
      // const blob1 = canvasDrawRef.current.getDataURL(); // blob
      // console.log('getDataURL DEFAULT', blob1);
      //
      // getDataURL(fileType, useBgImage, backgroundColour) will export the canvas to a data URL, which can subsequently be used to share or manipulate the image file.
      // if (!fileType) fileType = "png"; // Export the canvas to data URL
      /*
      } else if (backgroundColour != null) {
        //set background color
        context.fillStyle = backgroundColour; //fill entire canvas with background colour
        context.fillRect(0, 0, width, height);
      */
      // const blob2 = canvasDrawRef.current.getDataURL("png", null, "#ffffff"); // blob2
      const blob = canvasDrawRef.current.getDataURL("png", null, "white"); // blob
      setImgSrcBlob(blob);
      // console.log('getDataURL backgroundColour white', blob);
      return blob;
    }
  };
  //
  const handleClickSubmit = (e) => {
    // window.alert('UNDER CONSTRUCTION...');
    const img_src = handleExportImageFromCanvas();
    const token_from_signature_url = tokenFromSignatureURL;
    const data = {
      "token": token_from_signature_url,
      "signature_src": img_src,
      "accepts_terms": true,
    };
    _zzsurvey_ajax.createSignature(data)
      .then(response => {
        console.log('response createSignature', response);
        /*
        {
            "message": "Successfully created signature.",
            "signature": {
                "signature_id": 1,
                "accepts_terms": true,
                "signature_url": "/uploads/img_1746631302126.png",
                "date_created": "2025-05-07T15:21:42.000Z",
                "cdp_customer_id": 2,
                "consent_id": 1
            }
        }
        */
        if (response?.data?.signature?.signature_id) {
          setThankYou(true);
        }
      })
      .catch(err => {
        console.log('CATCH error getConsent');
        error_msg_handle(err);
      });
    //
    /*
    _zzsurvey_ajax.generateSignatureUrl(cdp_customer_id, consent_id)
      .then(response => {
        console.log('response generateSignatureUrl', response);
        if (response?.data?.url) {
          // const url = response.data.url;
          const url = new URL(response.data.url); //
          console.log('URL', url);
          const token_from_signature_url = url.searchParams.get("token");
          console.log('token_from_signature_url', token_from_signature_url);
          const img_src = handleExportImageFromCanvas();
          const data = {
            "token": token_from_signature_url,
            "signature_src": img_src,
            "accepts_terms": true,
          };
          _zzsurvey_ajax.createSignature(data)
            .then(response => {
              console.log('response createSignature', response);
              if (response?.data?.signature?.signature_id) {
                setThankYou(true);
              }
            })
        }
      })
      */
  };

  // render
  if (thankYou === true) {
    // <h1>Thank you for signing! :)</h1>
    // <h1>Hvala Vam na potpisu! :)</h1>
    return (
      <div className="zzsurvey-app">
        <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public">
          <div className="flex-1"></div>
          <div className="zzsurvey__landing-content">
            <div className="zzsurvey__pad-16px">
              <h1>Hvala Vam na potpisu! :)</h1>
            </div>
          </div>
          <div className="flex-2"></div>
        </div>
      </div>
    );
  } else if (canceled === true) {
    // <h1>Thank you for signing! :)</h1>
    // <h1>Hvala Vam na potpisu! :)</h1>
    return (
      <div className="zzsurvey-app">
        <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public">
          <div className="flex-1"></div>
          <div className="zzsurvey__landing-content">
            <div className="zzsurvey__pad-16px">
              <h1>Otkazali ste potpisivanje saglasnocti.</h1>
            </div>
          </div>
          <div className="flex-2"></div>
        </div>
      </div>
    );
  }
  //
  return (
    <>
      <div className="zzsurvey-app">

        <div className="zzsurvey__sign-form__wrapper">
          <div className="zzsurvey__sign-form__limiter">
            {/*<h1>Sign consent</h1>*/}
            <h1>Potpisivanje saglasnosti</h1>
            {/*
          <JSDisplayValue val={routeSimple} />
          */}
            {/*
            <FormFieldGenerator
              fieldDefinition={{
                "type": "input_text",
                "params": {
                  "readonly": true,
                  "label": "consent_id",
                  "name": "consent_id",
                  // "placeholder": "http://ratemyservice.rs",
                  "w": 120
                }
              }}
              value={consent_id}
              handleChange={() => { }}
            />
            */}
            {
              consent.fetching === true ? (
                <SpinnerClassic />
              ) : (
                <p>
                  {consent?.data?.text}
                </p>
              )
            }
            {/*
          <h3>Consent text</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          */}
            {
              consent.fetching === true ? (
                <SpinnerClassic />
              ) : (
                <div>
                  <h2>{consent?.data?.title}</h2>
                  <pre style={{
                    whiteSpace: 'pre-wrap'
                  }}>
                    {consent?.data?.terms_text}
                  </pre>
                </div>
              )
            }
            {
              consent.fetching === true ? (
                <>
                  <p>Molimo pričekajte...</p>
                </>
              ) : (
                <div>
                  <h2>Potpis</h2>
                  {/*<p>Sign by your finger in highlighted rectangle bellow (rotate your screen if needed):</p>*/}
                  <p>Potpišite prstom u istaknuto polje ispod (zarotirajte ekran ukoliko je potrebno):</p>

                  <div className="zzsurvey__sign-field-wrapper">
                    <div className="zzsurvey__sign-field">
                      <CanvasDraw
                        ref={canvasDrawRef}
                        lazyRadius={0}
                        brushRadius={1}
                        brushColor="rgb(0,0,0)"
                        catenaryColor="rgb(255,0,0)"
                        gridColor="rgba(150,150,150,0.17)"
                        hideGrid={false}
                        canvasWidth={480}
                        canvasHeight={240}
                      />
                    </div>
                  </div>

                  {/*<p>After signing press button bellow</p>*/}
                  <p>Nakon potpisivanja pritisnite taster "Pošalji"</p>
                  {/*<div>UNDER CONSTRUCTION...</div>*/}
                  <Btn
                    disabled={false}
                    circle
                    title='Pošalji potpis'
                    btnDialogSubmit
                    inline
                    handleClick={handleClickSubmit}
                  />
                </div>
              )
            }

            <div className="uu-gap-standalone-16px"></div>
            <Btn
              disabled={false}
              inline
              outline
              circle
              btnDialogCancel
              title='Otkaži'
              handleClick={() => { setCanceled(true); }}
            />
          </div>
          <div className="zzsurvey__layout-page-body-section-dev">
            <br />
            <Btn
              disabled={false}
              circle
              title='Test signature image'
              inline
              outline
              handleClick={handleExportImageFromCanvas}
            />
            <br />
            {
              imgSrcBlob && (
                <p><a download target="_blank" rel="noopener noreferrer" href={imgSrcBlob}>{'TEST open signauture image'}</a></p>
              )
            }
          </div>
        </div>
      </div>
    </>
  );
};
// <a target="_blank"

export default ZZTempSignConsent;

/*
_zzsurvey_ajax.generateSignatureUrl(cdp_customer_id, consent_id)
.then(response => {
  console.log('response generateSignatureUrl', response);
  
  {
      "message": "Successfully generated URL for signature page.",
      "url": "https://dev.ratemyservice.rs/signatures?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZHBfY3VzdG9tZXJfaWQiOiIyIiwiY29uc2VudF9pZCI6IjEiLCJpYXQiOjE3NDY2MzAwODQsImV4cCI6MTc0NjYzMzY4NH0.UUHQEuxVH6ZUWdPswALD1RANyIDDSn5leQCFb3hLfUc"
  }
*/